// extracted by mini-css-extract-plugin
module.exports = {"root":"new-landing-view_root___f9cU","extra-bold":"new-landing-view_extra-bold__Hn6Ss"};